import baseURL from "../baseUrl";
import { logger } from "../components/logger";

export const useUpdateData = async (url, params) => {
  const token = localStorage.getItem("token");
  //  const expireTimeStr = localStorage.getItem("expireTokenTime"); // "2025-05-15T10:24:01.449Z"

  const lang = localStorage.getItem("language") || "en";

  const headers = {
    Authorization: token ? `Bearer ${token}` : "",
    Accept: "application/json",
    lang: lang,
  };

  const res = await baseURL.put(url, params, { headers });
  return res.data;
};

export const useUpdateDataWithImage = async (url, params) => {
  const token = localStorage.getItem("token");
  const lang = localStorage.getItem("language") || "en";

  const updateConfig = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: token ? `Bearer ${token}` : "",
      lang: lang,
    },
  };
  const res = baseURL.put(url, params, updateConfig);
  return res;
};
